/* Uses the existing STOQ/Restock Rocket embed. No custom subscriber database or cart writes. */
(() => {
  if (customElements.get('vp-restock-signup')) return;
  class VarsityRestockSignup extends HTMLElement {
    connectedCallback() {
      if (this.bound) return;
      this.bound = true;
      this.button = this.querySelector('[data-vp-notify]');
      this.fallback = this.querySelector('[data-vp-fallback]');
      this.status = this.querySelector('[data-vp-status]');
      try { this.productData = JSON.parse(this.dataset.product); }
      catch (_) { return; }
      this.variantId = String(this.dataset.variantId || '');
      const variant = this.productData.variants?.find(item => String(item.id) === this.variantId);
      if (!variant || variant.available !== false || !this.button) return;
      this.onReady = event => {
        if (typeof event?.detail?.enabled === 'boolean') {
          this.stoqEnabled = event.detail.enabled;
        }
        const ready = this.stoqEnabled !== false && typeof window._RestockRocket?.openModal === 'function';
        this.button.hidden = !ready;
        this.fallback.hidden = ready;
      };
      this.onClick = () => {
        this.status.hidden = true;
        const api = window._RestockRocket;
        if (this.stoqEnabled === false || typeof api?.openModal !== 'function') { this.showError(); return; }
        try {
          Promise.resolve(api.openModal(this.productData, this.variantId)).catch(() => this.showError());
        } catch (_) { this.showError(); }
      };
      this.button.addEventListener('click', this.onClick);
      window.addEventListener('stoq:loaded', this.onReady);
      this.onReady();
      this.readyTimer = window.setTimeout(this.onReady, 4000);
    }
    showError() {
      this.status.textContent = 'The signup could not open. Please refresh or use the contact link above.';
      this.status.hidden = false;
      this.fallback.hidden = false;
    }
    disconnectedCallback() {
      window.clearTimeout(this.readyTimer);
      if (this.onReady) window.removeEventListener('stoq:loaded', this.onReady);
      if (this.onClick) this.button?.removeEventListener('click', this.onClick);
      this.bound = false;
    }
  }
  customElements.define('vp-restock-signup', VarsityRestockSignup);
})();
